import UpdateDialog from './UpdateDialog'; 

export default UpdateDialog;